import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';

interface IsValidProps {
  isValid: boolean;
}
interface IsInvalidProps {
  isInvalid: boolean;
}

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0, 0, 1, 1),
  display: 'flex',
  flexDirection: 'column',
}));

export const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const Field = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),
  position: 'relative',
}));

export const Label = styled('label', {
  shouldForwardProp: shouldForwardProp(),
})<IsValidProps>(({ isValid, theme }) => ({
  color: isValid ? theme.palette.error.main : theme.palette.text.secondary,
  fontSize: theme.typography.pxToRem(12),
  lineHeight: '20px',
  marginBottom: '11px',
}));

export const Input = styled('input', {
  shouldForwardProp: shouldForwardProp(),
})<IsInvalidProps>(({ isInvalid, theme }) => ({
  border: `solid ${theme.palette.grey[300]}`,
  borderBottomColor: isInvalid ? theme.palette.error.main : theme.palette.grey[300],
  borderWidth: '0 0 1px 0',
  boxSizing: 'border-box',
  fontSize: theme.typography.pxToRem(14),
  height: '28px',
  lineHeight: '19px',
  outline: 'none',
  padding: theme.spacing(2, 0),
}));

const buttonAndInformationBase: Record<string, string> = {
  backgroundColor: 'transparent',
  border: 'none',
  bottom: '0',
  cursor: 'pointer',
  fontSize: '30px',
  padding: '0',
  position: 'absolute',
  transition: '0.3s',
};

export const Information = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})<IsInvalidProps>(({ isInvalid, theme }) => ({
  ...buttonAndInformationBase,
  color: isInvalid ? theme.palette.error.main : theme.palette.grey[300],
  display: 'flex',
  opacity: isInvalid ? 1 : 0,
  right: 0,
}));

export const Button = styled('button', {
  shouldForwardProp: shouldForwardProp(),
})<IsInvalidProps & IsValidProps>(({ isInvalid, isValid, theme }) => ({
  ...buttonAndInformationBase,
  color: isValid ? theme.palette.primary.main : theme.palette.error.main,
  display: 'flex',
  right: isInvalid ? theme.spacing(6) : 0,
}));

export const ValidateInfo = styled('p')(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: theme.typography.pxToRem(12),
  lineHeight: '20px',
  margin: theme.spacing(0, 0, 2),
  [theme.breakpoints.up('sm')]: {
    marginBottom: 0,
  },
}));
